var AttachmentPreviewMethod;
(function (AttachmentPreviewMethod) {
    // Side-by-side preview not supported.
    AttachmentPreviewMethod[AttachmentPreviewMethod["Unsupported"] = 0] = "Unsupported";
    // Use the image lightbox UI to render the attachment.
    AttachmentPreviewMethod[AttachmentPreviewMethod["Image"] = 1] = "Image";
    // Use OWA to render an embedded mail item.
    AttachmentPreviewMethod[AttachmentPreviewMethod["MailItem"] = 2] = "MailItem";
    // Use OWA's calendar UI to reder the file (e.g. ICS).
    AttachmentPreviewMethod[AttachmentPreviewMethod["CalendarEvent"] = 3] = "CalendarEvent";
    // Use the WAC to render the file (e.g. Office docs).
    AttachmentPreviewMethod[AttachmentPreviewMethod["Wac"] = 4] = "Wac";
    // Use Suite Extensions to render the file (e.g. GPX).
    AttachmentPreviewMethod[AttachmentPreviewMethod["SuiteExtensions"] = 5] = "SuiteExtensions";
    // Use the audio player to render the file (e.g. MP3).
    AttachmentPreviewMethod[AttachmentPreviewMethod["Audio"] = 6] = "Audio";
    // Render the file as plain text.
    AttachmentPreviewMethod[AttachmentPreviewMethod["Text"] = 7] = "Text";
    // Use the native view for pdf files.
    AttachmentPreviewMethod[AttachmentPreviewMethod["NativeView"] = 8] = "NativeView";
    // View Google docs in iframe
    AttachmentPreviewMethod[AttachmentPreviewMethod["GoogleDoc"] = 9] = "GoogleDoc";
    // Use the PDF.js for pdf files.
    AttachmentPreviewMethod[AttachmentPreviewMethod["PdfJs"] = 10] = "PdfJs";
    // Use ItemReadingPane to render item attachment
    AttachmentPreviewMethod[AttachmentPreviewMethod["ItemAttachment"] = 11] = "ItemAttachment";
    // Use the video player to render the file (e.g. MP4)
    AttachmentPreviewMethod[AttachmentPreviewMethod["Video"] = 12] = "Video";
})(AttachmentPreviewMethod || (AttachmentPreviewMethod = {}));
export default AttachmentPreviewMethod;
//# sourceMappingURL=AttachmentPreviewMethod.js.map